import { Supplier } from "../Pages/Suppliers/model/Supplier.type";

export const data = [
    {
        "id": 1,
        "billCode": "1293",
        "firstName": "Lenovo Laptop",
        "lastName": "Japan",
        "city": "Tokyo",
        "state": "Tokyo",
        "status": "Active"
    },
    {
        "id": 2,
        "billCode": "2356",
        "firstName": "Samsung Galaxy S21",
        "lastName": "Seoul",
        "city": "Seoul",
        "state": "Seoul",
        "status": "Active"
    },
    {
        "id": 3,
        "billCode": "3789",
        "firstName": "Apple MacBook Pro",
        "lastName": "USA",
        "city": "New York",
        "state": "New York",
        "status": "Inactive"
    },
    {
        "id": 4,
        "billCode": "4871",
        "firstName": "Sony PlayStation 5",
        "lastName": "China",
        "city": "Beijing",
        "state": "Beijing",
        "status": "Active"
    },
    {
        "id": 5,
        "billCode": "5982",
        "firstName": "Dell XPS 15",
        "lastName": "Ireland",
        "city": "Dublin",
        "state": "Dublin",
        "status": "Active"
    },
    {
        "id": 6,
        "billCode": "6543",
        "firstName": "Huawei P40 Pro",
        "lastName": "China",
        "city": "Shanghai",
        "state": "Shanghai",
        "status": "Active"
    },
    {
        "id": 7,
        "billCode": "7891",
        "firstName": "Acer Predator 300",
        "lastName": "Taiwan",
        "city": "Taipei",
        "state": "Taipei",
        "status": "Active"
    },
    {
        "id": 8,
        "billCode": "8234",
        "firstName": "LG OLED TV",
        "lastName": "South Korea",
        "city": "Seoul",
        "state": "Seoul",
        "status": "Inactive"
    },
    {
        "id": 9,
        "billCode": "9456",
        "firstName": "Microsoft Surface Pro",
        "lastName": "USA",
        "city": "New York",
        "state": "New York",
        "status": "Active"
    },
];


export const ClientData = [
    {
        "id": 1,
        "clientCode": '2453',
        "clintName": 'Cutis Pharma',
        "wareHouse": 'West Houston',
        "city": 'Ohio',
        "state": 'Columbus',
        "status": true,
        "logo": "dummy-logo-0424-1.jpg"
    },
    {
        "id": 2,
        "clientCode": '2454',
        "clintName": 'Google',
        "wareHouse": 'West Houston',
        "city": 'Ohio',
        "state": 'Columbus',
        "status": true,
        "logo": "dummy-logo-0424-2.jpg"
    },
    {
        "id": 3,
        "clientCode": '2455',
        "clintName": 'Google',
        "wareHouse": 'West Houston',
        "city": 'Ohio',
        "state": 'Columbus',
        "status": true,
        "logo": "dummy-logo-0424-3.jpg"
    },
]

export const supplyDataList: Supplier[] = [
    {
        "id": 1,
        "supplierCode": "20155",
        "supplierName": "John Deo",
        "inventoryAccount": "",
        "currencyCode": '',
        "contactFirstName": '',
        "contactLastName": '',
        "contactEmail": "johndeo@gmail.com",
        "address1": '',
        "address2": '',
        "contactTelephone": "+1895858822",
        "city": "Ohio",
        "state": "Columbus",
        "postalCode": '',
        "country": '',
        "status": true
    },

];

export const itemsList = [
    {
        "id": 1,
        "itemCode": "Px098429292",
        "description": "Xbox 360",
        "itemType": "Components",
        "noComponent": "2",
        "uom": "EA",
        "status": "Active"
    },
    {
        "id": 2,
        "itemCode": "Px098429293",
        "description": "Xbox 360",
        "itemType": "Components",
        "noComponent": "2",
        "uom": "EA",
        "status": "Active"
    },
    {
        "id": 3,
        "itemCode": "Px098429294",
        "description": "Xbox 360",
        "itemType": "Components",
        "noComponent": "2",
        "uom": "EA",
        "status": "Active"
    },

];
export const companyAccountList = [
    {
        "accountId": 1,
        "accountName": "BAE Systems",
        "accountCode": "JS023",
        "warehouses": "1/10",
        "clients": "1/10",
        "users": "10/10",
        "createDate": "12/02/2024",
        "status": "Active"
    },
    {
        "accountId": 2,
        "accountName": "ACV Logistics",
        "accountCode": "JS024",
        "warehouses": "2/10",
        "clients": "2/10",
        "users": "10/10",
        "createDate": "12/02/2024",
        "status": "Setup"
    },
    {
        "accountId": 3,
        "accountName": "Bluegrass Magna",
        "accountCode": "JS025",
        "warehouses": "3/10",
        "clients": "1/10",
        "users": "10/10",
        "createDate": "12/02/2024",
        "status": "Inactive"
    },
    {
        "accountId": 4,
        "accountName": "MSL Packaging",
        "accountCode": "JS026",
        "warehouses": "2/10",
        "clients": "1/10",
        "users": "10/10",
        "createDate": "12/02/2024",
        "status": "Setup"
    },
]
export const roleList = [
    {
        "roleId": 1,
        "name": "Admin",
        "permission": "Inbound, Outbound, Inventory",
        "noOfAssignedUser": "2",
        "status": true
    },
    {
        "roleId": 2,
        "name": "Warehouse Admin",
        "permission": "Inbound, Outbound, Inventory",
        "noOfAssignedUser": "8",
        "status": true
    },
    {
        "roleId": 3,
        "name": "Warehouse Manager",
        "permission": "Inbound, Outbound, Inventory, Admin",
        "noOfAssignedUser": "0",
        "status": true
    },
    {
        "roleId": 4,
        "name": "Floor Manager",
        "permission": "Inbound, Outbound, Inventory, Admin",
        "noOfAssignedUser": "9",
        "status": true
    },
    {
        "roleId": 5,
        "name": "Supervise",
        "permission": "Inbound, Outbound, Inventory, Admin",
        "noOfAssignedUser": "5",
        "status": true
    },
    {
        "roleId": 6,
        "name": "Unload Staff",
        "permission": "Inbound, Outbound, Inventory, Admin",
        "noOfAssignedUser": "7",
        "status": true
    },
    {
        "roleId": 7,
        "name": "Receive Staff",
        "permission": "Inbound, Admin",
        "noOfAssignedUser": "5",
        "status": true
    },
    {
        "roleId": 8,
        "name": "Putaway Staff",
        "permission": "Inbound, Admin",
        "noOfAssignedUser": "5",
        "status": true
    },
]


export const inboundASNCheckInData = [
    {
        "ASN": "664892",
        "Supplier": "DHL",
        "Tracking": "12498",
        "Door": "Door 1",
        "ATA": "12/02/2023",
        "Status": "Check in Complete"
    },
    {
        "ASN": "ASN-664892",
        "Supplier": "DHL",
        "Tracking": "12498",
        "Door": "",
        "ATA": "12/02/2023",
        "Status": "Ready to Check in"
    },
    {
        "ASN": "789654",
        "Supplier": "FedEx",
        "Tracking": "47895",
        "Door": "Door 2",
        "ATA": "13/02/2023",
        "Status": "Check in Complete"
    },
    {
        "ASN": "ASN-789654",
        "Supplier": "FedEx",
        "Tracking": "47895",
        "Door": "",
        "ATA": "13/02/2023",
        "Status": "Ready to Check in"
    },
    {
        "ASN": "321654",
        "Supplier": "UPS",
        "Tracking": "98765",
        "Door": "Door 3",
        "ATA": "14/02/2023",
        "Status": "Check in Complete"
    },
    {
        "ASN": "ASN-321654",
        "Supplier": "UPS",
        "Tracking": "98765",
        "Door": "",
        "ATA": "14/02/2023",
        "Status": "Ready to Check in"
    },
    {
        "ASN": "654987",
        "Supplier": "TNT",
        "Tracking": "65432",
        "Door": "Door 4",
        "ATA": "15/02/2023",
        "Status": "Check in Complete"
    },
    {
        "ASN": "ASN-654987",
        "Supplier": "TNT",
        "Tracking": "65432",
        "Door": "",
        "ATA": "15/02/2023",
        "Status": "Ready to Check in"
    },
    {
        "ASN": "159753",
        "Supplier": "Amazon",
        "Tracking": "12345",
        "Door": "Door 5",
        "ATA": "16/02/2023",
        "Status": "Check in Complete"
    },
    {
        "ASN": "ASN-159753",
        "Supplier": "Amazon",
        "Tracking": "12345",
        "Door": "",
        "ATA": "16/02/2023",
        "Status": "Ready to Check in"
    },
    {
        "ASN": "664892",
        "Supplier": "DHL",
        "Tracking": "12498",
        "Door": "Door 1",
        "ATA": "12/02/2023",
        "Status": ""
    },
];

export const checkInDetailsData = [
    {
        "Line": "1",
        "ItemCode": {
            imgSrc: "phone1.jpg",
            text: "Ip125478"
        },
        "ItemDescription": "GARNIER SKIN NATURALS",
        "UOM": "EA",
        "ExpectedQty": "10",
        "BackorderQty": "2",
        "ReceivedQuantity": "8"
    },
    {
        "Line": "2",
        "ItemCode": {
            imgSrc: "phone1.jpg",
            text: "Mac125478"
        },
        "ItemDescription": "Mac Book",
        "UOM": "EA",
        "ExpectedQty": "02",
        "BackorderQty": "1",
        "ReceivedQuantity": "1"
    },    {
        "Line": "3",
        "ItemCode": {
            imgSrc: "phone1.jpg",
            text: "Mac125478"
        },
        "ItemDescription": "GARNIER SKIN NATURALS",
        "UOM": "EA",
        "ExpectedQty": "02",
        "BackorderQty": "1",
        "ReceivedQuantity": "13"
    }, 
    {
        "Line": "4",
        "ItemCode": {
            imgSrc: "phone1.jpg",
            text: "Mac125478"
        },
        "ItemDescription": "Mac Book",
        "UOM": "EA",
        "ExpectedQty": "02",
        "BackorderQty": "1",
        "ReceivedQuantity": "11"
    },    {
        "Line": "5",
        "ItemCode": {
            imgSrc: "phone1.jpg",
            text: "Mac125478"
        },
        "ItemDescription": "GARNIER SKIN NATURALS",
        "UOM": "EA",
        "ExpectedQty": "02",
        "BackorderQty": "1",
        "ReceivedQuantity": "21"
    },    {
        "Line": "6",
        "ItemCode": {
            imgSrc: "phone1.jpg",
            text: "Mac125478"
        },
        "ItemDescription": "GARNIER SKIN NATURALS",
        "UOM": "EA",
        "ExpectedQty": "02",
        "BackorderQty": "1",
        "ReceivedQuantity": "33"
    },
];

export const inboundASNOverviewNewData = [
    {
        "ASN": "ASN-1100178",
        "Supplier": "Apple",
        "ETA": "",
        "Door": "",
        "Lines": 4,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "New"
    },
    {
        "ASN": "ASN-1100178",
        "Supplier": "Target",
        "ETA": "",
        "Door": "",
        "Lines": 5,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Backorder"
    },
    {
        "ASN": "ASN-3344178",
        "Supplier": "Amazon",
        "ETA": "",
        "Door": "",
        "Lines": 4,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "New"
    },
    {
        "ASN": "ASN-6780178",
        "Supplier": "Techno",
        "ETA": "",
        "Door": "",
        "Lines": 2,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "New"
    },
    {
        "ASN": "ASN-8890178",
        "Supplier": "Huawei",
        "ETA": "",
        "Door": "",
        "Lines": 4,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "New"
    },
    {
        "ASN": "ASN-2309178",
        "Supplier": "Samsung",
        "ETA": "",
        "Door": "",
        "Lines": 9,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Backorder"
    },
    {
        "ASN": "ASN-1123178",
        "Supplier": "Walmart",
        "ETA": "",
        "Door": "",
        "Lines": 6,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "New"
    },
    {
        "ASN": "ASN-5567178",
        "Supplier": "CVS",
        "ETA": "",
        "Door": "",
        "Lines": 5,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "New"
    },
    {
        "ASN": "ASN-7780178",
        "Supplier": "Apple",
        "ETA": "",
        "Door": "",
        "Lines": 4,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "New"
    }
];

export const inboundASNOverviewInProgressData = [
    {
        "ASN": "8293921",
        "Supplier": "Apple",
        "ETA": "",
        "Door": "",
        "Lines": 4,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "1268532",
        "Supplier": "Amazon",
        "ETA": "",
        "Door": "",
        "Lines": 2,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "5566890",
        "Supplier": "Walmart",
        "ETA": "",
        "Door": "",
        "Lines": 4,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Ready to Unload"
    },
    {
        "ASN": "4467829",
        "Supplier": "Samsung",
        "ETA": "",
        "Door": "",
        "Lines": 8,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Ready to Unload"
    },
    {
        "ASN": "2344466",
        "Supplier": "Lenovo",
        "ETA": "",
        "Door": "",
        "Lines": 9,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "9922667",
        "Supplier": "Apple",
        "ETA": "",
        "Door": "",
        "Lines": 4,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Ready to Unload"
    },
    {
        "ASN": "1100775",
        "Supplier": "Huawei",
        "ETA": "",
        "Door": "",
        "Lines": 6,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Ready to Receive"
    },
    {
        "ASN": "ASN-1100178",
        "Supplier": "Apple",
        "ETA": "",
        "Door": "",
        "Lines": 2,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Ready to Receive"
    },
    {
        "ASN": "1125091",
        "Supplier": "CVS",
        "ETA": "",
        "Door": "",
        "Lines": 3,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Ready to Receive"
    },
    {
        "ASN": "2839211",
        "Supplier": "Apple",
        "ETA": "",
        "Door": "",
        "Lines": 4,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Ready to Putaway"
    },
    {
        "ASN": "3698768",
        "Supplier": "CVS",
        "ETA": "",
        "Door": "",
        "Lines": 8,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Ready to Putaway"
    }
];

export const inboundASNOverviewCompletedData = [
    {
        "ASN": "3243324",
        "Supplier": "Techno",
        "ETA": "",
        "Door": "",
        "Lines": 7,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Completed"
    },
    {
        "ASN": "5548933",
        "Supplier": "Lenovo",
        "ETA": "",
        "Door": "",
        "Lines": 1,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Completed"
    },
    {
        "ASN": "5686965",
        "Supplier": "Target",
        "ETA": "",
        "Door": "",
        "Lines": 4,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Completed"
    },
    {
        "ASN": "6546589",
        "Supplier": "Walmart",
        "ETA": "",
        "Door": "",
        "Lines": 8,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Completed"
    },
    {
        "ASN": "5432432",
        "Supplier": "Samsung",
        "ETA": "",
        "Door": "",
        "Lines": 3,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Completed"
    },
    {
        "ASN": "6456879",
        "Supplier": "CVS",
        "ETA": "",
        "Door": "",
        "Lines": 9,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Completed"
    },
    {
        "ASN": "6546458",
        "Supplier": "CVS",
        "ETA": "",
        "Door": "",
        "Lines": 6,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Completed"
    },
    {
        "ASN": "5677909",
        "Supplier": "Apple",
        "ETA": "",
        "Door": "",
        "Lines": 2,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Completed"
    },
    {
        "ASN": "8780088",
        "Supplier": "MSI",
        "ETA": "",
        "Door": "",
        "Lines": 4,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Completed"
    },
    {
        "ASN": "4536530",
        "Supplier": "Samsung",
        "ETA": "",
        "Door": "",
        "Lines": 6,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Completed"
    },
    {
        "ASN": "4663008",
        "Supplier": "Apple",
        "ETA": "",
        "Door": "",
        "Lines": 4,
        "ReceivedQty": 0,
        "PutawayQty": 0,
        "Status": "Completed"
    }
];


export const InboundAsnLineItemsList = [
    {
        "line":"1",
        "itemCode": "IP-29839",
        "desc": "IPhone XS",
        "uom": "EA",
        "quantityOnHand": 29,
        "expectedQuantity": 0,
        "itemImg": "phone1.jpg"
    },
    {
        "line":"2",
        "itemCode": "IP-23839",
        "desc": "IPhone 14",
        "uom": "EA",
        "quantityOnHand": 25,
        "expectedQuantity": 0,
        "itemImg": "phone1.jpg"
    },
    {
        "itemCode": "IP-02198",
        "desc": "IPhone 6s",
        "uom": "EA",
        "quantityOnHand": 25,
        "expectedQuantity": 0,
        "itemImg": "phone1.jpg"
    },
    {
        "itemCode": "IP-12908",
        "desc": "IPhone X",
        "uom": "EA",
        "quantityOnHand": 25,
        "expectedQuantity": 0,
        "itemImg": "phone1.jpg"
    },
    {
        "itemCode": "IP-38011",
        "desc": "IPhone XS Max",
        "uom": "EA",
        "quantityOnHand": 25,
        "expectedQuantity": 0,
        "itemImg": "phone1.jpg"
    },

]
export const itemCodeDropdownData = [
    {
        "Line": "1",
        "ItemCode": "IP-12908",
        "imgSrc": "phone1.jpg",
        "desc": "IPhone X",
        "uom": "EA",
        "expectedQuantity": "10",
        "backorderQty": "2",
        "receivedQuantity": "25",
        "quantityOnHand": "4"

    },
	    {
        "line": "2",
        "itemCode": "Ip125478",
        "imgSrc": "phone1.jpg",
        "desc": "GARNIER SKIN NATURALSs",
        "uom": "EA",
        "expectedQuantity": "10",
        "backorderQty": "2",
        "receivedQuantity": "25",
        "quantityOnHand": "4"

    },   
     {
        "line": "3",
        "itemCode": "Ip125478",
        "imgSrc": "phone1.jpg",
        "desc": "IPhone XS Max",
        "uom": "EA",
        "expectedQuantity": "10",
        "backorderQty": "2",
        "receivedQuantity": "25",
        "quantityOnHand": "4"

    },

];

export const inboundPurchaseOrderList = [
    {
        "poId": "1",
        "po": "20158",
        "supplier": "Target",
        "lines": "4",
        "dateCreate": "12/05/2022",
        "status": "open",
    },
    {
        "poId": "2",
        "po": "20158",
        "supplier": "Target",
        "lines": "4",
        "dateCreate": "12/05/2022",
        "status": "open"
    },
    {
        "poId": "3",
        "po": "20158",
        "supplier": "Target",
        "lines": "4",
        "dateCreate": "12/05/2022",
        "status": "open"
    },
    {
        "poId": "4",
        "po": "20158",
        "supplier": "Target",
        "lines": "4",
        "dateCreate": "12/05/2022",
        "status": "open"
    },
    {
        "poId": "5",
        "po": "20158",
        "supplier": "Target",
        "lines": "4",
        "dateCreate": "12/05/2022",
        "status": "open"
    },
    {
        "poId": "6",
        "po": "20158",
        "supplier": "Target",
        "lines": "4",
        "dateCreate": "12/05/2022",
        "status": "open"
    },
    {
        "poId": "7",
        "po": "20158",
        "supplier": "Target",
        "lines": "4",
        "dateCreate": "12/05/2022",
        "status": "open"
    },
    {
        "poId": "8",
        "po": "20158",
        "supplier": "Target",
        "lines": "4",
        "dateCreate": "12/05/2022",
        "status": "open"
    },
    {
        "poId": "9",
        "po": "20158",
        "supplier": "Target",
        "lines": "4",
        "dateCreate": "12/05/2022",
        "status": "open"
    },
    {
        "poId": "10",
        "po": "20158",
        "supplier": "Target",
        "lines": "4",
        "dateCreate": "12/05/2022",
        "status": "open"
    },
]
export const inboundASNPutawayList = [
    {
        "REC": "RE-3342178",
        "ASN": "ASN-1100178",
        "Supplier": "Apple",
        "Tracking": "TTL-5567",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "New"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-1100178",
        "Supplier": "Target",
        "Tracking": "TQL-1109",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "New"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-3344178",
        "Supplier": "Amazon",
        "Tracking": "QTL-5112",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "New"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-6780178",
        "Supplier": "Techno",
        "Tracking": "POL-5098",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "New"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-8890178",
        "Supplier": "Huawei",
        "Tracking": "QWE-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "New"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-2309178",
        "Supplier": "Samsung",
        "Tracking": "ASA-5567",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "New"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-1123178",
        "Supplier": "Walmart",
        "Tracking": "CVX-5379",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "New"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-5567178",
        "Supplier": "CVS",
        "Tracking": "XAZ-5009",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "New"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-7780178",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "New"
    }
];
export const inboundASNPutawayInProgressData = [
    {
        "REC": "RE-3342178",
        "ASN": "8293921",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "1268532",
        "Supplier": "Amazon",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "5566890",
        "Supplier": "Walmart",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "4467829",
        "Supplier": "Samsung",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "2344466",
        "Supplier": "Lenovo",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "9922667",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "1100775",
        "Supplier": "Huawei",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-1100178",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "1125091",
        "Supplier": "CVS",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "2839211",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "3698768",
        "Supplier": "CVS",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Ready to Check-in"
    }
];
export const inboundASNPutawayCompletedData = [
    {
        "REC": "RE-3342178",
        "ASN": "8293921",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "1268532",
        "Supplier": "Amazon",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "5566890",
        "Supplier": "Walmart",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "4467829",
        "Supplier": "Samsung",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "2344466",
        "Supplier": "Lenovo",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "9922667",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "1100775",
        "Supplier": "Huawei",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-1100178",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "1125091",
        "Supplier": "CVS",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "2839211",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "3698768",
        "Supplier": "CVS",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "ATA": "03/10/2023",
        "Status": "Completed"
    }
];

export const inboundASNReceiveList = [
    {
        "ASN": "ASN-1100178",
        "Supplier": "Apple",
        "Tracking": "TTL-5567",
        "Location": "A1-P1",
        "Status": "New"
    },
    {
        "ASN": "ASN-1100178",
        "Supplier": "Target",
        "Tracking": "TQL-1109",
        "Location": "A1-P1",
        "Status": "Backorder"
    },
    {
        "ASN": "ASN-3344178",
        "Supplier": "Amazon",
        "Tracking": "QTL-5112",
        "Location": "A1-P1",
        "Status": "New"
    },
    {
        "ASN": "ASN-6780178",
        "Supplier": "Techno",
        "Tracking": "POL-5098",
        "Location": "A1-P1",
        "Status": "New"
    },
    {
        "ASN": "ASN-8890178",
        "Supplier": "Huawei",
        "Tracking": "QWE-5445",
        "Location": "A1-P1",
        "Status": "New"
    },
    {
        "ASN": "ASN-2309178",
        "Supplier": "Samsung",
        "Tracking": "ASA-5567",
        "Location": "A1-P1",
        "Status": "Backorder"
    },
    {
        "ASN": "ASN-1123178",
        "Supplier": "Walmart",
        "Tracking": "CVX-5379",
        "Location": "A1-P1",
        "Status": "New"
    },
    {
        "ASN": "ASN-5567178",
        "Supplier": "CVS",
        "Tracking": "XAZ-5009",
        "Location": "A1-P1",
        "Status": "New"
    },
    {
        "ASN": "ASN-7780178",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "New"
    }
];
export const inboundASNReceiveInProgressData = [
    {
        "ASN": "8293921",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "1268532",
        "Supplier": "Amazon",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "5566890",
        "Supplier": "Walmart",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "4467829",
        "Supplier": "Samsung",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "2344466",
        "Supplier": "Lenovo",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "9922667",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "1100775",
        "Supplier": "Huawei",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "ASN-1100178",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "1125091",
        "Supplier": "CVS",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "2839211",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "3698768",
        "Supplier": "CVS",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    }
];
export const inboundASNReceiveCompletedData = [
    {
        "ASN": "8293921",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "ASN": "1268532",
        "Supplier": "Amazon",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "ASN": "5566890",
        "Supplier": "Walmart",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "ASN": "4467829",
        "Supplier": "Samsung",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "ASN": "2344466",
        "Supplier": "Lenovo",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "ASN": "9922667",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "ASN": "1100775",
        "Supplier": "Huawei",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "ASN": "ASN-1100178",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "ASN": "1125091",
        "Supplier": "CVS",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "ASN": "2839211",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "ASN": "3698768",
        "Supplier": "CVS",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    }
];
export const inboundASNUnloadList = [
    {
        "REC": "RE-3342178",
        "ASN": "ASN-1100178",
        "Supplier": "Apple",
        "Tracking": "TTL-5567",
        "Location": "A1-P1",
        "Status": "New"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-1100178",
        "Supplier": "Target",
        "Tracking": "TQL-1109",
        "Location": "A1-P1",
        "Status": "New"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-3344178",
        "Supplier": "Amazon",
        "Tracking": "QTL-5112",
        "Location": "A1-P1",
        "Status": "New"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-6780178",
        "Supplier": "Techno",
        "Tracking": "POL-5098",
        "Location": "A1-P1",
        "Status": "New"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-8890178",
        "Supplier": "Huawei",
        "Tracking": "QWE-5445",
        "Location": "A1-P1",
        "Status": "New"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-2309178",
        "Supplier": "Samsung",
        "Tracking": "ASA-5567",
        "Location": "A1-P1",
        "Status": "New"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-1123178",
        "Supplier": "Walmart",
        "Tracking": "CVX-5379",
        "Location": "A1-P1",
        "Status": "New"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-5567178",
        "Supplier": "CVS",
        "Tracking": "XAZ-5009",
        "Location": "A1-P1",
        "Status": "New"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-7780178",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "New"
    }
];
export const inboundASNUnloadInProgressData = [
    {
        "REC": "RE-3342178",
        "ASN": "8293921",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "1268532",
        "Supplier": "Amazon",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "5566890",
        "Supplier": "Walmart",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "4467829",
        "Supplier": "Samsung",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "2344466",
        "Supplier": "Lenovo",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "9922667",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "1100775",
        "Supplier": "Huawei",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-1100178",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "1125091",
        "Supplier": "CVS",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "2839211",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    },
    {
        "REC": "RE-3342178",
        "ASN": "3698768",
        "Supplier": "CVS",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Ready to Check-in"
    }
];
export const inboundASNUnloadCompletedData = [
    {
        "REC": "RE-3342178",
        "ASN": "8293921",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "1268532",
        "Supplier": "Amazon",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "5566890",
        "Supplier": "Walmart",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "4467829",
        "Supplier": "Samsung",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "2344466",
        "Supplier": "Lenovo",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "9922667",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "1100775",
        "Supplier": "Huawei",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "ASN-1100178",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "1125091",
        "Supplier": "CVS",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "2839211",
        "Supplier": "Apple",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    },
    {
        "REC": "RE-3342178",
        "ASN": "3698768",
        "Supplier": "CVS",
        "Tracking": "HUH-5445",
        "Location": "A1-P1",
        "Status": "Completed"
    }
];
export const inboundReturnOverviewNewData = [
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "New"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "New"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "New"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "New"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "New"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "New"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "New"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "New"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "New"
    },
];
export const inboundReturnInProgressData = [
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Ready to Check-in"
    },
];
export const inboundReturnCompletedData = [
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100178",
        "Order": "OR-15155",
        "Lines": 4,
        "RDate": '12/04/2022',
        "Status": "Completed"
    },
];
export const inboundReturnCheckInData = [
    {
        "ASN": "664892",
        "Supplier": "DHL",
        "Tracking": "12498",
        "Door": "Door 1",
        "ATA": "12/02/2023",
        "Status": "Ready to Check in"
    },
    {
        "ASN": "ASN-664892",
        "Supplier": "DHL",
        "Tracking": "12498",
        "Door": "",
        "ATA": "12/02/2023",
        "Status": "Ready to Check in"
    },
    {
        "ASN": "789654",
        "Supplier": "FedEx",
        "Tracking": "47895",
        "Door": "Door 2",
        "ATA": "13/02/2023",
        "Status": "Ready to Check in"
    },
    {
        "ASN": "ASN-789654",
        "Supplier": "FedEx",
        "Tracking": "47895",
        "Door": "",
        "ATA": "13/02/2023",
        "Status": "Ready to Check in"
    },
    {
        "ASN": "321654",
        "Supplier": "UPS",
        "Tracking": "98765",
        "Door": "Door 3",
        "ATA": "14/02/2023",
        "Status": "Ready to Check in"
    },
    {
        "ASN": "ASN-321654",
        "Supplier": "UPS",
        "Tracking": "98765",
        "Door": "",
        "ATA": "14/02/2023",
        "Status": "Ready to Check in"
    },
    {
        "ASN": "654987",
        "Supplier": "TNT",
        "Tracking": "65432",
        "Door": "Door 4",
        "ATA": "15/02/2023",
        "Status": "Ready to Check in"
    },
    {
        "ASN": "ASN-654987",
        "Supplier": "TNT",
        "Tracking": "65432",
        "Door": "",
        "ATA": "15/02/2023",
        "Status": "Ready to Check in"
    },
    {
        "ASN": "159753",
        "Supplier": "Amazon",
        "Tracking": "12345",
        "Door": "Door 5",
        "ATA": "16/02/2023",
        "Status": "Ready to Check in"
    },
    {
        "ASN": "ASN-159753",
        "Supplier": "Amazon",
        "Tracking": "12345",
        "Door": "",
        "ATA": "16/02/2023",
        "Status": "Ready to Check in"
    },
    {
        "ASN": "664892",
        "Supplier": "DHL",
        "Tracking": "12498",
        "Door": "Door 1",
        "ATA": "12/02/2023",
        "Status": "Ready to Check in"
    },
];
export const inboundReturnCheckInCompleteData = [
    {
        "ASN": "664892",
        "Supplier": "DHL",
        "Tracking": "12498",
        "Door": "Door 1",
        "ATA": "12/02/2023",
        "Status": "Check in Complete"
    },
    {
        "ASN": "ASN-664892",
        "Supplier": "DHL",
        "Tracking": "12498",
        "Door": "",
        "ATA": "12/02/2023",
        "Status": "Check in Complete"
    },
    {
        "ASN": "789654",
        "Supplier": "FedEx",
        "Tracking": "47895",
        "Door": "Door 2",
        "ATA": "13/02/2023",
        "Status": "Check in Complete"
    },
    {
        "ASN": "ASN-789654",
        "Supplier": "FedEx",
        "Tracking": "47895",
        "Door": "",
        "ATA": "13/02/2023",
        "Status": "Check in Complete"
    },
    {
        "ASN": "321654",
        "Supplier": "UPS",
        "Tracking": "98765",
        "Door": "Door 3",
        "ATA": "14/02/2023",
        "Status": "Check in Complete"
    },
    {
        "ASN": "ASN-321654",
        "Supplier": "UPS",
        "Tracking": "98765",
        "Door": "",
        "ATA": "14/02/2023",
        "Status": "Check in Complete"
    },
    {
        "ASN": "654987",
        "Supplier": "TNT",
        "Tracking": "65432",
        "Door": "Door 4",
        "ATA": "15/02/2023",
        "Status": "Check in Complete"
    },
    {
        "ASN": "ASN-654987",
        "Supplier": "TNT",
        "Tracking": "65432",
        "Door": "",
        "ATA": "15/02/2023",
        "Status": "Check in Complete"
    },

];
export const uloadAddData = [
    {
        "Line": "1",
        "ItemCode": {
            imgSrc: "phone1.jpg",
            text: "Ip125478"
        },
        "ItemDescription": "GARNIER SKIN NATURALS ...",
        "UOM": "EA",
        "ExpectedQty": "10",
        "ReceivedQuantity": "25",
        "PutawayQuantity": "25",
    }
];
export const inboundReturnsUnloadList = [
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "New"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "New"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "New"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "New"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "New"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "New"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "New"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "New"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "New"
    },
];
export const inboundReturnsUnloadProcess = [
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Ready to Check-in"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Ready to Check-in"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Ready to Check-in"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Ready to Check-in"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Ready to Check-in"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Ready to Check-in"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Ready to Check-in"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Ready to Check-in"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Ready to Check-in"
    },
];
export const inboundReturnsUnloadComplete = [
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Completed"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Completed"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Completed"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Completed"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Completed"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Completed"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Completed"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Completed"
    },
    {
        "RT": "RT-1100178",
        "Supplier": "Cutis Pharma",
        "Tracking": "JRE-2958",
        "Door": "19-Door",
        "ATA": "04/11/2020",
        "Status": "Completed"
    },
];
export const inboundReturnsReceiveList = [
    {
        "ASN": "RT-1100178",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "New"
    },
    {
        "ASN": "RT-1100178",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "New"
    },
    {
        "ASN": "RT-1100178",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "New"
    },
    {
        "ASN": "RT-1100178",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "New"
    },
    {
        "ASN": "RT-1100178",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "New"
    },
    {
        "ASN": "RT-1100178",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "New"
    },
    {
        "ASN": "RT-1100178",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "New"
    },
    {
        "ASN": "RT-1100178",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "New"
    },
    {
        "ASN": "RT-1100178",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "New"
    }
];
export const inboundReturnReceiveInProgressData = [
    {
        "ASN": "RT-1100188",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100188",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100188",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100188",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100188",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100188",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100188",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100188",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100188",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100188",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Ready to Check-in"
    },
    {
        "ASN": "RT-1100188",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Ready to Check-in"
    }
];
export const inboundReturnsReceiveCompletedData = [
    {
        "ASN": "RT-1100180",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100180",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100180",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100180",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100180",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100180",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100180",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100180",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100180",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100180",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Completed"
    },
    {
        "ASN": "RT-1100180",
        "Supplier": "DHL",
        "Tracking": "TTL-5567",
        "Door": "1-Door",
        "ATA": "12/02/2023",
        "Status": "Completed"
    }
];
export const checkInDetailsReturnPutawayData = [
    {
        "Line": "1",
        "ItemCode": {
            imgSrc: "phone1.jpg",
            text: "Ip125478"
        },
        "ItemDescription": "GARNIER SKIN NATURALS ...",
        "UOM": "EA",
        "ExpectedQty": "0",
        "BackorderQty": "2",
        "ReceivedQuantity": "25",
        "quantityOnHand": "4"

    },
    {
        "Line": "2",
        "ItemCode": {
            imgSrc: "phone1.jpg",
            text: "Mac125478"
        },
        "ItemDescription": "Mac Book",
        "UOM": "EA",
        "ExpectedQty": "0",
        "BackorderQty": "1",
        "ReceivedQuantity": "32",
        "quantityOnHand": "2"
    },
    {
        "Line": "3",
        "ItemCode": {
            imgSrc: "phone1.jpg",
            text: "Mac082024"
        },
        "ItemDescription": "Mac Pro Book",
        "UOM": "EA",
        "ExpectedQty": "0",
        "BackorderQty": "1",
        "ReceivedQuantity": "40",
        "quantityOnHand": "45"
    },
    {
        "Line": "4",
        "ItemCode": {
            imgSrc: "phone1.jpg",
            text: "Ip125478"
        },
        "ItemDescription": "GARNIER SKIN NATURALS ...",
        "UOM": "EA",
        "ExpectedQty": "0",
        "BackorderQty": "2",
        "ReceivedQuantity": "25",
        "quantityOnHand": "4"

    },
    {
        "Line": "5",
        "ItemCode": {
            imgSrc: "phone1.jpg",
            text: "Mac125478"
        },
        "ItemDescription": "Mac Book",
        "UOM": "EA",
        "ExpectedQty": "0",
        "BackorderQty": "1",
        "ReceivedQuantity": "32",
        "quantityOnHand": "2"
    },
    {
        "Line": "6",
        "ItemCode": {
            imgSrc: "phone1.jpg",
            text: "Mac082024"
        },
        "ItemDescription": "Mac Pro Book",
        "UOM": "EA",
        "ExpectedQty": "0",
        "BackorderQty": "1",
        "ReceivedQuantity": "40",
        "quantityOnHand": "45"
    },
];


export const addLineItem = [
    {
        "Line": "1",
        "ItemCode": "Ip125478",
        "imgSrc": "phone1.jpg",
        "ItemDescription": "GARNIER SKIN NATURALS ...",
        "UOM": "EA",
        "ExpectedQty": "0",
        "BackorderQty": "2",
        "ReceivedQuantity": "25",
        "quantityOnHand": "4"

    },
    {
        "Line": "2",
        "ItemCode": "Mac082024",
        "imgSrc": "phone1.jpg",
        "ItemDescription": "Mac Pro Book",
        "UOM": "EA",
        "ExpectedQty": "0",
        "BackorderQty": "1",
        "ReceivedQuantity": "40",
        "quantityOnHand": "45"
    },
    {
        "Line": "3",
        "ItemCode": "Mac125478",
        "imgSrc": "phone1.jpg",
        "ItemDescription": "Mac Book",
        "UOM": "EA",
        "ExpectedQty": "0",
        "BackorderQty": "1",
        "ReceivedQuantity": "32",
        "quantityOnHand": "2"
    },
   

];
export const addLineItemforAsn = [
    {
        "Line": "1",
        "ItemCode": "Ip125478",
        "imgSrc": "phone1.jpg",
        "ItemDescription": "GARNIER SKIN NATURALS ...",
        "UOM": "EA",
        "ExpectedQty": "0",
        "BackorderQty": "2",
        "ReceivedQuantity": "25",
        "quantityOnHand": "4"

    },
    {
        "Line": "2",
        "ItemCode": "Mac082024",
        "imgSrc": "phone1.jpg",
        "ItemDescription": "Mac Pro Book",
        "UOM": "EA",
        "ExpectedQty": "0",
        "BackorderQty": "1",
        "ReceivedQuantity": "40",
        "quantityOnHand": "45"
    },
    {
        "Line": "3",
        "ItemCode": "Mac125478",
        "imgSrc": "phone1.jpg",
        "ItemDescription": "Mac Book",
        "UOM": "EA",
        "ExpectedQty": "0",
        "BackorderQty": "1",
        "ReceivedQuantity": "32",
        "quantityOnHand": "2"
    },
   

];
export const PutawayLocationDataList = [
    {
        "id": "1",
        "cLocation": "A1-P1",
        "qnt": "25"
    },
    {
        "id": "1",
        "cLocation": "B1-P1",
        "qnt": "32"
    },
    {
        "id": "1",
        "cLocation": "C1-P1",
        "qnt": "40"
    },
]
export const inventoryOverviewList = [
    {
        "inv": "1",
        "invItemCode": "MB254878",
        "invDesc": "MacBook Pro",
        "invQtyOnHand": "25",
        "invQtyOnReserved": "10",
        "invQtyOnAvailable": "15",
        "invQtyOnExpected": "200",
        "invQtyOnFuture": "215",
    },
    {
        "inv": "2",
        "invItemCode": "IP254879",
        "invDesc": "iPad Mini",
        "invQtyOnHand": "100",
        "invQtyOnReserved": "80",
        "invQtyOnAvailable": "150",
        "invQtyOnExpected": "50",
        "invQtyOnFuture": "250",
    },
    {
        "inv": "3",
        "invItemCode": "AT124578",
        "invDesc": "AirTag",
        "invQtyOnHand": "250",
        "invQtyOnReserved": "150",
        "invQtyOnAvailable": "300",
        "invQtyOnExpected": "100",
        "invQtyOnFuture": "500",
    },
    {
        "inv": "4",
        "invItemCode": "MB456845",
        "invDesc": "MacBook Air",
        "invQtyOnHand": "25",
        "invQtyOnReserved": "10",
        "invQtyOnAvailable": "200",
        "invQtyOnExpected": "200",
        "invQtyOnFuture": "200",
    },
    {
        "inv": "5",
        "invItemCode": "IP254878",
        "invDesc": "iPhone 14",
        "invQtyOnHand": "25",
        "invQtyOnReserved": "10",
        "invQtyOnAvailable": "200",
        "invQtyOnExpected": "200",
        "invQtyOnFuture": "200",
    },
    {
        "inv": "6",
        "invItemCode": "AW123546",
        "invDesc": "Apple Watch",
        "invQtyOnHand": "25",
        "invQtyOnReserved": "10",
        "invQtyOnAvailable": "200",
        "invQtyOnExpected": "200",
        "invQtyOnFuture": "200",
    },
    {
        "inv": "7",
        "invItemCode": "HP321654",
        "invDesc": "HomePod",
        "invQtyOnHand": "25",
        "invQtyOnReserved": "10",
        "invQtyOnAvailable": "200",
        "invQtyOnExpected": "200",
        "invQtyOnFuture": "200",
    },
    {
        "inv": "9",
        "invItemCode": "VP659287",
        "invDesc": "Vision Pro",
        "invQtyOnHand": "25",
        "invQtyOnReserved": "10",
        "invQtyOnAvailable": "200",
        "invQtyOnExpected": "200",
        "invQtyOnFuture": "200",
    },
    {
        "inv": "10",
        "invItemCode": "IP254878",
        "invDesc": "iPhone 14 Plus",
        "invQtyOnHand": "25",
        "invQtyOnReserved": "10",
        "invQtyOnAvailable": "200",
        "invQtyOnExpected": "200",
        "invQtyOnFuture": "200",
    },

]
export const inventoryOverviewLocationList = [
    {
        "id": "1",
        "cLocation": "A1-A-P1",
        "qnt": "4",
        "tag": "2",
        "serial": "2"
    },
    {
        "id": "2",
        "cLocation": "P1-A-P2",
        "qnt": "33",
        "tag": "16",
        "serial": "17"
    },
    {
        "id": "3",
        "cLocation": "B1-A-P2",
        "qnt": "12",
        "tag": "4",
        "serial": "8"
    },
]
export const inventoryAvailByInvStatusList = [
    {
        "invStatus": "PD Inventory",
        "invCode": "1",
        "available": "260",
        "orders": "10",
        "availNow": "250",
        "asn": "20"
    },
    {
        "invStatus": "Finished Go",
        "invCode": "1",
        "available": "63242",
        "orders": "0",
        "availNow": "187",
        "asn": "0"
    },
    {
        "invStatus": "Returns 100",
        "invCode": "101",
        "available": "3199",
        "orders": "0",
        "availNow": "187",
        "asn": "0"
    },
    {
        "invStatus": "QC Hold 100",
        "invCode": "102",
        "available": "105",
        "orders": "0",
        "availNow": "187",
        "asn": "0"
    },
    {
        "invStatus": "Raw Material",
        "invCode": "103",
        "available": "60",
        "orders": "0",
        "availNow": "187",
        "asn": "0"
    },
    {
        "invStatus": "Damage",
        "invCode": "104",
        "available": "187",
        "orders": "0",
        "availNow": "187",
        "asn": "0"
    },
    {
        "invStatus": "Lost Inventory",
        "invCode": "105",
        "available": "187",
        "orders": "0",
        "availNow": "187",
        "asn": "0"
    },
    {
        "invStatus": "Found Inventory",
        "invCode": "106",
        "available": "187",
        "orders": "0",
        "availNow": "187",
        "asn": "0"
    },
    {
        "invStatus": "My new Inventory",
        "invCode": "107",
        "available": "187",
        "orders": "0",
        "availNow": "187",
        "asn": "0"
    },
    {
        "invStatus": "SDF",
        "invCode": "108",
        "available": "187",
        "orders": "0",
        "availNow": "187",
        "asn": "0"
    },
    {
        "invStatus": "QC Hold 200",
        "invCode": "111",
        "available": "187",
        "orders": "0",
        "availNow": "187",
        "asn": "0"
    },
    {
        "invStatus": "SDF",
        "invCode": "108",
        "available": "187",
        "orders": "0",
        "availNow": "187",
        "asn": "0"
    },
]
export const inventoryReceivingHisList = [
    {
        "recNo": "50565",
        "date": "5/31/2023",
        "asn": "381",
        "supName": "Chunky Panday",
        "primRef": "-",
        "invStatus": "Test inventory account",
        "qtyReceived": "200"
    },
    {
        "recNo": "50565",
        "date": "5/31/2023",
        "asn": "428",
        "supName": "Chunky Panday",
        "primRef": "-",
        "invStatus": "Test inventory account",
        "qtyReceived": "80"
    },
    {
        "recNo": "50562",
        "date": "5/31/2023",
        "asn": "412",
        "supName": "Chunky Panday",
        "primRef": "-",
        "invStatus": "Test inventory account",
        "qtyReceived": "2000"
    },
    {
        "recNo": "50561",
        "date": "5/31/2023",
        "asn": "404",
        "supName": "D Supplier",
        "primRef": "0012",
        "invStatus": "Returns 100",
        "qtyReceived": "300"
    },
    {
        "recNo": "50558",
        "date": "5/31/2023",
        "asn": "462",
        "supName": "Ali Khan",
        "primRef": "-",
        "invStatus": "Finished goods",
        "qtyReceived": "300"
    },
    {
        "recNo": "50553",
        "date": "5/31/2023",
        "asn": "685",
        "supName": "Supplier 3",
        "primRef": "-",
        "invStatus": "Test inventory account",
        "qtyReceived": "01"
    },
    {
        "recNo": "50552",
        "date": "5/31/2023",
        "asn": "682",
        "supName": "Supplier 3",
        "primRef": "-",
        "invStatus": "Test inventory account",
        "qtyReceived": "01"
    },
]
export const inventoryShippingHistoryList = [
    {
        "shipment": "1000002",
        "shipDate": "09/19/2023",
        "orderNo": "1004",
        "shipToName": "test",
        "primRef": "-",
        "qtyShipped": "20"
    }
]
export const shippingHistoryDispModalDataList = [
    {
        "lnNo": "1",
        "qtyO": "20",
        "qtys": "20",
        "pCode": "ABCHL",
        "desc": "Absorotion Chiller",
        "uom": "EA",
        "price": "-",
        "extn": "-"
    },
    {
        "lnNo": "2",
        "qtyO": "15",
        "qtys": "14",
        "pCode": "ABFSD",
        "desc": "Absorotion Chiller",
        "uom": "EA",
        "price": "-",
        "extn": "-"
    },
    {
        "lnNo": "3",
        "qtyO": "18",
        "qtys": "12",
        "pCode": "AFASS",
        "desc": "Absorotion Chiller",
        "uom": "EA",
        "price": "-",
        "extn": "-"
    },
    {
        "lnNo": "4",
        "qtyO": "22",
        "qtys": "11",
        "pCode": "GDAAA",
        "desc": "Absorotion Chiller",
        "uom": "EA",
        "price": "-",
        "extn": "-"
    },
    {
        "lnNo": "5",
        "qtyO": "25",
        "qtys": "20",
        "pCode": "RWFDA",
        "desc": "Absorotion Chiller",
        "uom": "EA",
        "price": "-",
        "extn": "-"
    },
]
export const InventoryDetailsList = [
    {
        "invStatus": "Damaged Goods",
        "qtyOh": "1",
        "qtyAll": "0",
        "lotNo": "-",
        "tagNo": "B1S632306",
        "slNo": "B1S632306",
        "binLoc": "BIN1-A",
    },
    {
        "invStatus": "Lost Inventory",
        "qtyOh": "1",
        "qtyAll": "0",
        "lotNo": "-",
        "tagNo": "B1S6448291",
        "slNo": "B1S632306",
        "binLoc": "BIN1-A",
    },
    {
        "invStatus": "Lost Inventory",
        "qtyOh": "1",
        "qtyAll": "0",
        "lotNo": "-",
        "tagNo": "B1S6448211",
        "slNo": "B1S632306",
        "binLoc": "BIN1-B",
    },
    {
        "invStatus": "Lost Inventory",
        "qtyOh": "1",
        "qtyAll": "0",
        "lotNo": "-",
        "tagNo": "B1S6448232",
        "slNo": "B1S632306",
        "binLoc": "BIN1-B",
    },
    {
        "invStatus": "Lost Inventory",
        "qtyOh": "1",
        "qtyAll": "0",
        "lotNo": "-",
        "tagNo": "B1S6448212",
        "slNo": "B1S632306",
        "binLoc": "BIN1-B",
    },
]
export const inventoryHistoryList = [
    {
        "invStatus": "Finished Goods",
        "lotNo": "/",
        "tagNo": "/",
        "binLoc": "AATISAMA-ARC",
        "lastShipNo": "1004",
        "lastQty": "20"
    }
]
export const inventoryTransactionHistoryList = [
    {
        "trsn": "Shipment",
        "refNo": "100002",
        "date": "09/16/2022",
        "qty": "10",
        "fmBin": "AATISAMA",
        "toBin": "-",
        "frmInvNo": "100",
        "toInvNo": "-",
    },
    {
        "trsn": "Shipment",
        "refNo": "100003",
        "date": "09/16/2022",
        "qty": "10",
        "fmBin": "AATISAMA",
        "toBin": "-",
        "frmInvNo": "100",
        "toInvNo": "-",
    },
    {
        "trsn": "Shipment",
        "refNo": "100004",
        "date": "09/16/2022",
        "qty": "10",
        "fmBin": "AATISAMA",
        "toBin": "-",
        "frmInvNo": "100",
        "toInvNo": "-",
    },
    {
        "trsn": "Shipment",
        "refNo": "100005",
        "date": "09/16/2022",
        "qty": "10",
        "fmBin": "AATISAMA",
        "toBin": "-",
        "frmInvNo": "100",
        "toInvNo": "-",
    },
    {
        "trsn": "Shipment",
        "refNo": "100006",
        "date": "09/16/2022",
        "qty": "10",
        "fmBin": "AATISAMA",
        "toBin": "-",
        "frmInvNo": "100",
        "toInvNo": "-",
    },
    {
        "trsn": "Shipment",
        "refNo": "100007",
        "date": "09/16/2022",
        "qty": "10",
        "fmBin": "AATISAMA",
        "toBin": "-",
        "frmInvNo": "100",
        "toInvNo": "-",
    },
    {
        "trsn": "Shipment",
        "refNo": "100008",
        "date": "09/16/2022",
        "qty": "10",
        "fmBin": "AATISAMA",
        "toBin": "-",
        "frmInvNo": "100",
        "toInvNo": "-",
    },
    {
        "trsn": "Shipment",
        "refNo": "100009",
        "date": "09/16/2022",
        "qty": "10",
        "fmBin": "AATISAMA",
        "toBin": "-",
        "frmInvNo": "100",
        "toInvNo": "-",
    },
    {
        "trsn": "Shipment",
        "refNo": "100009",
        "date": "09/16/2022",
        "qty": "10",
        "fmBin": "AATISAMA",
        "toBin": "-",
        "frmInvNo": "100",
        "toInvNo": "-",
    },
    {
        "trsn": "Shipment",
        "refNo": "100009",
        "date": "09/16/2022",
        "qty": "10",
        "fmBin": "AATISAMA",
        "toBin": "-",
        "frmInvNo": "100",
        "toInvNo": "-",
    },
    {
        "trsn": "Shipment",
        "refNo": "100009",
        "date": "09/16/2022",
        "qty": "10",
        "fmBin": "AATISAMA",
        "toBin": "-",
        "frmInvNo": "100",
        "toInvNo": "-",
    },
    {
        "trsn": "Shipment",
        "refNo": "100009",
        "date": "09/16/2022",
        "qty": "10",
        "fmBin": "AATISAMA",
        "toBin": "-",
        "frmInvNo": "100",
        "toInvNo": "-",
    },
    {
        "trsn": "Shipment",
        "refNo": "100009",
        "date": "09/16/2022",
        "qty": "10",
        "fmBin": "AATISAMA",
        "toBin": "-",
        "frmInvNo": "100",
        "toInvNo": "-",
    },
    {
        "trsn": "Shipment",
        "refNo": "100009",
        "date": "09/16/2022",
        "qty": "10",
        "fmBin": "AATISAMA",
        "toBin": "-",
        "frmInvNo": "100",
        "toInvNo": "-",
    },

]

export const invStatusDataList = [
    {
        "itemCode": "MB254878",
        "desc": "MackBook Pro",

        "qtyhand": "25",
        "recQty": "10",
        "avlNow": "15",
        "expQty": "200"
    },
    {
        "itemCode": "MB123234",
        "desc": "MackBook Pro",
        "qtyhand": "25",
        "recQty": "10",
        "avlNow": "15",
        "expQty": "200"
    },
    {
        "itemCode": "MB141414",
        "desc": "MackBook Pro",
        "qtyhand": "25",
        "recQty": "10",
        "avlNow": "15",
        "expQty": "200"
    },
    {
        "itemCode": "853532",
        "desc": "MackBook Pro",
        "qtyhand": "25",
        "recQty": "10",
        "avlNow": "15",
        "expQty": "200"
    },
]
export const inventoryStatusOptionList = [
    { "label": "Damage", "value": "1" },
    { "label": "QC Hold", "value": "2" },
    { "label": "Reserved", "value": "3" },
]

export const inventoryStatusFinishedGoodsList = [
    {
        "location": "B1-A-A1",
        "optList": inventoryStatusOptionList,
        "qty": "10",
        "trfQty": ""
    },
    {
        "location": "B1-A-B1",
        "optList": inventoryStatusOptionList,
        "qty": "08",
        "trfQty": ""
    },
    {
        "location": "C1-B-P2",
        "optList": inventoryStatusOptionList,
        "qty": "07",
        "trfQty": ""
    },

]
export const inventoryStatusQCHoldList = [
    {
        "location": "B1-A-A1",
        "optList": { inventoryStatusOptionList },
        "qty": "10",
        "trfQty": ""
    },
    {
        "location": "B1-A-B1",
        "optList": { inventoryStatusOptionList },
        "qty": "08",
        "trfQty": ""
    },
    {
        "location": "C1-B-P2",
        "optList": { inventoryStatusOptionList },
        "qty": "07",
        "trfQty": ""
    },

]
export const inventoryStatusDamageList = [
    {
        "location": "A1-A-P1",
        "optList": { inventoryStatusOptionList },
        "qty": "10",
        "trfQty": ""
    },
    {
        "location": "B1-A-B1",
        "optList": { inventoryStatusOptionList },
        "qty": "08",
        "trfQty": ""
    },
    {
        "location": "C1-B-P2",
        "optList": { inventoryStatusOptionList },
        "qty": "07",
        "trfQty": ""
    },
    {
        "location": "A1-A-P2",
        "optList": { inventoryStatusOptionList },
        "qty": "07",
        "trfQty": ""
    },

]
export const cardexinquirylist = [

    {
        "invStatus": "Finished Goods",
        "postedDate": "09/19/2022",
        "refNo": "10023",
        "type": "Sales",
        "priorQty": "710",
        "qtyInOut": "10-",
        "balance": "700",
        "custSupp": "test"
    },
    {
        "invStatus": "PD Inventory",
        "postedDate": "11/19/2022",
        "refNo": "02911",
        "type": "Sales",
        "priorQty": "720",
        "qtyInOut": "10-",
        "balance": "710",
        "custSupp": "test"
    },
    {
        "invStatus": "Body 1-fntnhbrrhrh1",
        "postedDate": "Body 1-2",
        "refNo": "Body 1-3",
        "type": "Body 1-4vevrvrgv",
        "priorQty": "Body 1-5",
        "qtyInOut": "Body 1-6",
        "balance": "Body 1-7",
        "custSupp": "Body 1-8eevr"
    },
    {
        "invStatus": "Body 1-fntnhbrrhrh1",
        "postedDate": "Body 1-2",
        "refNo": "Body 1-3",
        "type": "Body 1-4vevrvrgv",
        "priorQty": "Body 1-5",
        "qtyInOut": "Body 1-6",
        "balance": "Body 1-7",
        "custSupp": "Body 1-8eevr"
    },
    {
        "invStatus": "Body 1-fntnhbrrhrh1",
        "postedDate": "Body 1-2",
        "refNo": "Body 1-3",
        "type": "Body 1-4vevrvrgv",
        "priorQty": "Body 1-5",
        "qtyInOut": "Body 1-6",
        "balance": "Body 1-7",
        "custSupp": "Body 1-8eevr"
    },
    {
        "invStatus": "Body 1-fntnhbrrhrh1",
        "postedDate": "Body 1-2",
        "refNo": "Body 1-3",
        "type": "Body 1-4vevrvrgv",
        "priorQty": "Body 1-5",
        "qtyInOut": "Body 1-6",
        "balance": "Body 1-7",
        "custSupp": "Body 1-8eevr"
    },
    {
        "invStatus": "Body 2-1",
        "postedDate": "Body 2vrgvgrvgv-2",
        "refNo": "Body 2-3",
        "type": "Body 2-4crfvrgv",
        "priorQty": "Body 2-5",
        "qtyInOut": "Body 2-6",


        "balance": "Body 2-ervtgv7",
        "custSupp": "Body 2-8"
    }

]
export const transferoverviewlist = [
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "transferBy": "By Item",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "transferBy": "By Item",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "transferBy": "By Item",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "transferBy": "By Item",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "transferBy": "By Item",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "transferBy": "By Item",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "transferBy": "By Item",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "transferBy": "By Item",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "transferBy": "By Item",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "transferBy": "By Item",
        "assignedTo": "-",
        "status": "New"
    },
]

export const replenishmentoverviewcompletedlist = [
    {
        "replenishmentNum": "857124123",
        "description": "Replenishment Temp 1",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 2",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 3",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 4",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 5",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 6",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 7",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 8",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 9",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 10",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "Completed"
    },
]

export const replenishmentoverviewinprogresslist = [
    {
        "replenishmentNum": "85741223",
        "description": "Replenishment Temp 1",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "In Progress"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 2",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "In Progress"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 3",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "In Progress"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 4",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "In Progress"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 5",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "In Progress"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 6",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "In Progress"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 7",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "In Progress"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 8",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "In Progress"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 9",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "In Progress"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 10",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "In Progress"
    },
]

export const replenishmentoverview = [
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 1",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 2",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 3",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 4",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 5",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 6",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 7",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 8",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 9",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "New"
    },
    {
        "replenishmentNum": "8574123",
        "description": "Replenishment Temp 10",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "assignedTo": "-",
        "status": "New"
    },

]

export const cyclecountoverviewcompletedlist = [
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "completed"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "completed"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "completed"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "completed"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "completed"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "completed"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "completed"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "completed"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "completed"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "completed"
    },
]


export const cyclecountoverviewpendingreviewlist = [
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "pending_review"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "pending_review"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "pending_review"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "pending_review"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "pending_review"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "pending_review"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "pending_review"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "pending_review"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "pending_review"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "pending_review"
    },

]

export const cyclecountoverviewinprogresslist = [
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "in_progress"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "in_progress"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "in_progress"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "in_progress"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "in_progress"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "in_progress"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "in_progress"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "in_progress"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "in_progress"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "in_progress"
    },
]

export const cyclecountoverviewnewlist = [
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "new"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "new"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "new"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "new"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "new"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "15/03/2020",
        "recount": "6",
        "status": "new"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "new"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "new"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Location",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "new"
    },
    {
        "cycle_count": "8574123",
        "count_type": "By Item",
        "counted_date": "03/15/2020",
        "recount": "6",
        "status": "new"
    },

]

export const cyclecountdetailslist = [
    {
        "line": "1",
        "item_code": {
            imgSrc: "phone1.jpg",
            text: "IP-29828"
        },
        "system_qty": "55",
        "counted_qty": "50",
        "varience": "-5",
        "location": "A1-P-A2",
        "cost": "-$500",
        "recount_qty": "52",
        "recount": 0,
        "is_recounted": 0
    },
    {
        "line": "2",
        "item_code": {
            imgSrc: "phone1.jpg",
            text: "IP-29829"
        },
        "system_qty": "20",
        "counted_qty": "18",
        "varience": "-3",
        "location": "B1-P-P2",
        "cost": "-$700",
        "recount_qty": "19",
        "recount": 0,
        "is_recounted": 0
    },
    {
        "line": "3",
        "item_code": {
            imgSrc: "phone1.jpg",
            text: "IP-29830"
        },
        "system_qty": "85",
        "counted_qty": "90",
        "varience": "5",
        "location": "A1-P-A2",
        "cost": "$200",
        "recount_qty": "88",
        "recount": 0,
        "is_recounted": 0
    },
    {
        "line": "4",
        "item_code": {
            imgSrc: "phone1.jpg",
            text: "IP-29831"
        },
        "system_qty": "22",
        "counted_qty": "20",
        "varience": "-2",
        "location": "C1-P-C2",
        "cost": "-$300",
        "recount_qty": "20",
        "recount": 0,
        "is_recounted": 0
    },
    {
        "line": "5",
        "item_code": {
            imgSrc: "phone1.jpg",
            text: "IP-29832"
        },
        "system_qty": "10",
        "counted_qty": "9",
        "varience": "-1",
        "location": "P1-P-B2",
        "cost": "-$500",
        "recount_qty": "8",
        "recount": 0,
        "is_recounted": 1
    },

]

export const inventoryStatusQtyDetails = [
    {
        "item_code": "IP-29828",
        "inventory_status": "Finished Goods",
        "system_qty": "20"
    },
    {
        "item_code": "IP-29829",
        "inventory_status": "Reserved",
        "system_qty": "20"
    },
    {
        "item_code": "IP-29830",
        "inventory_status": "QC Hold",
        "system_qty": "15"
    },
]

export const transferoverviewinprogresslist = [
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "transferBy": "By Item",
        "assignedTo": "Robert",
        "status": "In Progress"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "2",
        "transferBy": "By Item",
        "assignedTo": "John",
        "status": "In Progress"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "transferBy": "By Item",
        "assignedTo": "Robert",
        "status": "In Progress"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "2",
        "transferBy": "By Item",
        "assignedTo": "John",
        "status": "In Progress"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "transferBy": "By Item",
        "assignedTo": "Robert",
        "status": "In Progress"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "2",
        "transferBy": "By Item",
        "assignedTo": "John",
        "status": "In Progress"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "transferBy": "By Item",
        "assignedTo": "Robert",
        "status": "In Progress"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "2",
        "transferBy": "By Item",
        "assignedTo": "John",
        "status": "In Progress"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "transferBy": "By Item",
        "assignedTo": "Robert",
        "status": "In Progress"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "2",
        "transferBy": "By Item",
        "assignedTo": "John",
        "status": "In Progress"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "6",
        "transferBy": "By Item",
        "assignedTo": "Robert",
        "status": "In Progress"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Brouce",
        "createOn": "15/03/2020",
        "noOfLines": "2",
        "transferBy": "By Item",
        "assignedTo": "John",
        "status": "In Progress"
    },


]
export const transferoverviewcompletedlist = [
    {
        "transferNum": "8574123",
        "createdBy": "Robert",
        "createOn": "15/03/2020",
        "noOfLines": "4",
        "transferBy": "By Item",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "transferNum": "8574124",
        "createdBy": "John",
        "createOn": "15/03/2020",
        "noOfLines": "9",
        "transferBy": "Full Bin",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Robert",
        "createOn": "15/03/2020",
        "noOfLines": "4",
        "transferBy": "By Item",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "transferNum": "8574123",
        "createdBy": "John",
        "createOn": "15/03/2020",
        "noOfLines": "9",
        "transferBy": "Full Bin",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Robert",
        "createOn": "15/03/2020",
        "noOfLines": "4",
        "transferBy": "By Item",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "transferNum": "8574123",
        "createdBy": "John",
        "createOn": "15/03/2020",
        "noOfLines": "9",
        "transferBy": "Full Bin",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Robert",
        "createOn": "15/03/2020",
        "noOfLines": "4",
        "transferBy": "By Item",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "transferNum": "8574123",
        "createdBy": "John",
        "createOn": "15/03/2020",
        "noOfLines": "9",
        "transferBy": "Full Bin",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Robert",
        "createOn": "15/03/2020",
        "noOfLines": "4",
        "transferBy": "By Item",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "transferNum": "8574123",
        "createdBy": "John",
        "createOn": "15/03/2020",
        "noOfLines": "9",
        "transferBy": "Full Bin",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "transferNum": "8574123",
        "createdBy": "Robert",
        "createOn": "15/03/2020",
        "noOfLines": "4",
        "transferBy": "By Item",
        "assignedTo": "-",
        "status": "Completed"
    },
    {
        "transferNum": "8574123",
        "createdBy": "John",
        "createOn": "15/03/2020",
        "noOfLines": "9",
        "transferBy": "Full Bin",
        "assignedTo": "-",
        "status": "Completed"
    },


]
export const transferdetailslist = [
    {
        "line": "1",
        "itemCode": "IP-192910",
        "itemDesc": "IPhone XS",
        "uom": "EA1",
        "from": "A1-A-A1",
        "to": "Pl -A-P2",
        "actualQty": "30",
        "transferredQty": 25

    },
    {
        "line": "2",
        "itemCode": "IP-235391",
        "itemDesc": "IPhone 14",
        "uom": "EA2",
        "from": "Pl -A-P2",
        "to": "CI-B-AI",
        "actualQty": "35",
        "transferredQty": 30
    }

]


export const replenishmentdetailslist = [
    {
        "line": "1",
        "itemCode": "IP-192910",
        "itemDesc": "IPhone XS",
        "qtyOnHand": 25,
        "qtyAvailableNow": 35,
        "minStockLevel": 10,
        "maxStockLevel": 1000,
        "from": "Al-A-P2",
        "to": "Bl-A-P2",
        "transferQty": 25

    },
    {
        "line": "3",
        "itemCode": "IP-192910",
        "itemDesc": "IPhone XS",
        "qtyOnHand": 75,
        "qtyAvailableNow": 65,
        "minStockLevel": 40,
        "maxStockLevel": 1034,
        "from": "A2-A-P2",
        "to": "B4-A-P2",
        "transferQty": 67

    },

]
export const inventoryoverviewdetailsnew = [
    {
        "asn": "ASN-1100178",
        "supplier": "Apple",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Target",
        "eta": "-",
        "door": "-",
        "lines": "5",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "backorder"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Amazon",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Techno",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Huawei",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Samsung",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "backorder"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Walmart",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "CVS",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Apple",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },


]
export const inventoryoverviewdetailsinprogress = [
    {
        "asn": "ASN-1100178",
        "supplier": "Apple",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Target",
        "eta": "-",
        "door": "-",
        "lines": "5",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "backorder"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Amazon",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Techno",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Huawei",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Samsung",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "backorder"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Walmart",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "CVS",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Apple",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },


]
export const inventoryoverviewdetailscompleted = [
    {
        "asn": "ASN-1100178",
        "supplier": "Apple",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Target",
        "eta": "-",
        "door": "-",
        "lines": "5",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "backorder"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Amazon",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Techno",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Huawei",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Samsung",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "backorder"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Walmart",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "CVS",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },
    {
        "asn": "ASN-1100178",
        "supplier": "Apple",
        "eta": "-",
        "door": "-",
        "lines": "4",
        "receivedQty": "0",
        "putawayQty": "0",
        "status": "new"
    },


]
export const vieworderdetailslist = [
    {
        "shipment": "SH-100011",
        "noOfLines": "2",
        "shippedDate": "12/04/2022",
        "shippedQty": "12/04/2022"
    },
    {
        "shipment": "SH-100011",
        "noOfLines": "5",
        "shippedDate": "12/04/2022",
        "shippedQty": "12/04/2022"
    },
    {
        "shipment": "SH-100011",
        "noOfLines": "6",
        "shippedDate": "12/04/2022",
        "shippedQty": "12/04/2022"
    },
    {
        "shipment": "SH-100011",
        "noOfLines": "2",
        "shippedDate": "12/04/2022",
        "shippedQty": "12/04/2022"
    },
    {
        "shipment": "SH-100011",
        "noOfLines": "2",
        "shippedDate": "12/04/2022",
        "shippedQty": "12/04/2022"
    },
]





export const dropDownFromList = [
    { value: 'C1-B-A1', label: 'C1-B-A1' },
    { value: 'A1-A-A2', label: 'A1-A-A2' },
    { value: 'B1-B-B2', label: 'B1-B-B2' }
]

export const dropDownItemCode = [
    { value: 'IP-23339', label: 'IP-23339' },
    { value: 'IT-23229', label: 'IT-23229' },
    { value: 'IR-29539', label: 'IR-29539' }
]

export const dropDownToList = [
    { value: 'P1-A-P2', label: 'P1-A-P2' },
    { value: 'A1-A-A1', label: 'A1-A-A1' },
    { value: 'B1-B-B2', label: 'B1-B-B2' }
]

export const InvStatusList = [
    { value: '01 Selected', label: '01 Selected' },
    { value: '02 Selected', label: '02 Selected' },
    { value: '03 Selected', label: '03 Selected' }
]

export const initialData = [
    { lineNumber: 1, itemCode: 'IP-23539', uom: 'EA1', from: 'C1-B-A1', to: 'P1-A-P2', transferQty: 23, itemDescription: 'iPhone 14', invStatus: '01 Selected' },
    { lineNumber: 2, itemCode: 'IR-29539', uom: 'EA2', from: 'A1-A-A2', to: 'P1-A-P2', transferQty: 45, itemDescription: 'iPhone XS', invStatus: '02 Selected' },
];


export const DataFromAPI = [
    { lineNumber: 1, itemCode: 'IR-29539', uom: 'SA1', from: 'C1-B-A1', to: 'P1-A-P2', transferQty: 23, itemDescription: 'iPhone 14', invStatus: '01 Selected' },
    { lineNumber: 2, itemCode: 'IP-29823', uom: 'SA2', from: 'A1-A-A2', to: 'P1-A-P2', transferQty: 45, itemDescription: 'iPhone XS', invStatus: '02 Selected' },
];


export const DataFromAPI2 = [
    { lineNumber: 1, fromBin: 'C1-B-A1', toBin: 'P1-A-P2', availableQty: 23, },
    { lineNumber: 2, fromBin: 'D2-B-D1', toBin: 'K1-A-PK2', availableQty: 26, },
];

// DataFromAPI3 example
export const DataFromAPI3 = [
    { line: 1, itemCode: 'IR-29539', uom: 'SA1', expectedQty: 23, itemDescription: 'iPhone 14' },
    { line: 2, itemCode: 'IP-29839', uom: 'SA2', expectedQty: 45, itemDescription: 'iPhone XS' },
];


const dropDownFromBin = [
    { location: 'A1-A-A1', quantity: 25 },
    { location: 'P1-A-P2', quantity: 30 },
    { location: 'C1-B-A1', quantity: 55 },
];

const headers = [
    { key: 'location', label: 'Location' },
    { key: 'quantity', label: 'Quantity' },
];


export const transfereditlist = [
    {
        "line": "1",
        "itemCode": "IP-192910",
        "itemDesc": "IPhone XS",
        "uom": "EA",
        "from": [{
            name: "C1-B-A1",
            value: "C1-B-A1"
        },
        {
            name: "A1-A-A1",
            value: "02 Selected"
        }
        ],
        "to": [{
            name: "P1-A-P2",
            value: "P1-A-P2"
        },
        {
            name: "Option 2",
            value: "Option 2"
        }
        ],
        "transferQty": "30",
        "invStatus": [{
            name: "01 Selected",
            value: "01 Selected"
        },
        {
            name: "02 Selected",
            value: "02 Selected"
        }
        ]
    },
    {
        "line": "1",
        "itemCode": "IP-191510",
        "itemDesc": "IPhone 14",
        "uom": "EA",
        "from": [{
            name: "C1-B-A1",
            value: "C1-B-A1"
        },
        {
            name: "A1-A-A1",
            value: "02 Selected"
        }
        ],
        "to": [{
            name: "P1-A-P2",
            value: "P1-A-P2"
        },
        {
            name: "Option 2",
            value: "Option 2"
        }
        ],
        "transferQty": "30",
        "invStatus": [{
            name: "01 Selected",
            value: "01 Selected"
        },
        {
            name: "02 Selected",
            value: "02 Selected"
        }
        ]
    },

]


export const Zone = [
    
]

export const inventoryadjustmentlist = [
    {
        "adjustmentCode": "8574123",
        "createdBy": "Robert Pet",
        "complementDate": "03/15/2020",
        "status": "completed"
    },
    {
        "adjustmentCode": "8574123",
        "createdBy": "John William",
        "complementDate": "03/15/2020",
        "status": "in_progress"
    },
    {
        "adjustmentCode": "8574123",
        "createdBy": "Joey Jill",
        "complementDate": "03/15/2020",
        "status": "completed"
    },
    {
        "adjustmentCode": "8574123",
        "createdBy": "Peter Rose",
        "complementDate": "03/15/2020",
        "status": "completed"
    },
    {
        "adjustmentCode": "8574123",
        "createdBy": "Cameron Lane",
        "complementDate": "03/15/2020",
        "status": "in_progress"
    },
    {
        "adjustmentCode": "8574123",
        "createdBy": "Rose Jack",
        "complementDate": "03/15/2020",
        "status": "in_progress"
    },
    {
        "adjustmentCode": "8574123",
        "createdBy": "Joey Jill",
        "complementDate": "03/15/2020",
        "status": "completed"
    },
    {
        "adjustmentCode": "8574123",
        "createdBy": "Peter Rose",
        "complementDate": "03/15/2020",
        "status": "in_progress"
    },
    {
        "adjustmentCode": "8574123",
        "createdBy": "Rose Jack",
        "complementDate": "03/15/2020",
        "status": "in_progress"
    },
    {
        "adjustmentCode": "8574123",
        "createdBy": "Joey Jill",
        "complementDate": "03/15/2020",
        "status": "completed"
    },

]

export const adjustmentdetailslist = [
    {
        "line": "1",
        "itemCode": "IP-192910",
        "itemDesc": "IPhone XS",
        "uom": "EA",
        "adjustedQty": -25,
        "binLocation": "P1-B-P2",
    },
    {
        "line": "2",
        "itemCode": "IP-55451",
        "itemDesc": "IPhone 14",
        "uom": "EA",
        "adjustedQty": -20,
        "binLocation": "P1-B-P2",
    },
]

export const adjustmentdetails = [
    {
    "createdBy": "John William",
    "invStatus": "Finished Goods",
    "createdDate": "03/15/2023",
    "reasonCode": "1232",
    "completedDate": "03/16/2020",
    "status": "New",
  }
]



export const kitordersoverviewnewlist = [
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "new"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "new"
    },
    {
       "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "new"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "new"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "new"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "new"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "new"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "new"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "new"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "new"
    },

]


export const kitordersoverviewinprogresslist = [
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "in_progress"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "in_progress"
    },
    {
       "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "in_progress"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "in_progress"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "in_progress"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "in_progress"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "in_progress"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "in_progress"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "in_progress"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "in_progress"
    },
]


export const kitordersoverviewcompletelist = [
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "completed"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "completed"
    },
    {
       "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "completed"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "completed"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "completed"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "completed"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "completed"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "completed"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "completed"
    },
    {
        "kit_order": "1321412411",
        "kit_part": "1213wd",
        "kit_description": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kits_available": "8",
        "status": "completed"
    },
]


export const kitOrderDetailsList = [
    {
        "kit_part": "1213wd",
        "kit_desc": "Kit-Assembly-Two-Pieces",
        "kit_order_qty": "10",
        "kit_available": "8"
    }

]


export const kitordercontentdetails = [
    {
        "line": "1",
        "item_code": "44321234",
        "item_name": "Iphone",
        "UOM": "EA",
        "item_qty": "14"
    },
    {
        "line": "2",
        "item_code": "54321234",
        "item_name": "Tablet",
        "UOM": "EA",
        "item_qty": "80"
    },
    {
        "line": "3",
        "item_code": "34321234",
        "item_name": "Macbook",
        "UOM": "EA",
        "item_qty": "20"
    },
]

export const formInvStatus = [
    { inv_acct: '100', quantity: 20 },
    { inv_acct: '200', quantity: 5 },
    { inv_acct: '300', quantity: 10 },
];
export const HistoryLaoutData = [
    {
      "day": "Today",
      "items": [
        {
          "time": "7:00:18 AM (CST)",
          "description": "Stock Transfer Completed Having Qty 32 85741231",
          "person": "Zack Brown",
          "status": "Completed"
        },
        {
          "time": "6:45:00 AM (CST)",
          "description": "Stock Transfer In Progress Having Qty 22 8574124",
          "person": "Zack Brown",
          "status": "In Progress"
        },
        {
          "time": "6:30:13 AM (CST)",
          "description": "Stock Transfer In Progress Having Qty 10 8574125",
          "person": "Zack Brown",
          "status": "In Progress"
        },
        {
          "time": "6:00:13 AM (CST)",
          "description": "Stock Transfer created Having Qty 10 85741261",
          "person": "Zack Brown",
          "status": "New"
        }
      ]
    },
    {
      "day": "Yesterday",
      "items": [
        {
          "time": "7:30:00 PM (CST)",
          "description": "Check-in Complete Qty 50 [#ASN-11001 7B]",
          "person": "Zack Brown",
          "status": "Check-in Complete"
        },
        {
          "time": "7:00:13 PM (CST)",
          "description": "Ready To Check-in Qty 50 [#ASN-11 781]",
          "person": "Zack Brown",
          "status": "Ready to Check-in"
        },
        {
          "time": "6:00:13 PM (CST)",
          "description": "ASN Created Qty 50 [#ASN-11001781]",
          "person": "Bobby Brown",
          "status": "New"
        }
      ]
    }
  ];
  
  


export const HistoryLaoutDataKitOrderDetail = [
    {
      day: "Today",
    //   viewscanlog: 'View Scan Logs',
      items: [
        {
          time: "6:45:00 AM (CST)",
          description: "Kit Order In Progress Having Qty 22 8574124",
          person: "Zack Brown",
          status: "In Progress",
        },
        {
          time: "6:30:13 AM (CST)",
          description: "Kit Order In Progress Having Qty 10 8574125",
          person: "Zack Brown",
          status: "In Progress",
        },
        {
          time: "6:00:13 AM (CST)",
          description: "Kit Order created Having Qty 10 85741261",
          person: "Zack Brown",
          status: "New",
        },
      ],
    },
  ];
  export const HistoryLaoutDataCheckInDetail= [
    {
        day: "Today",
        items: [
            {
              time: "3:30:13 PM (cST)",
              description: "Putaway Completed [# ASN-110728]",
              person: "Mathew Fox",
              status: "Putaway Complete",
            },
            {
                time: "3:30:13 PM (cST)",
                description: "Putaway Completed [# ASN-110728]",
                person: "Mathew Fox",
                status: "Putaway Complete",
              },
              {
                time: "3:30:13 PM (cST)",
                description: "Putaway Completed [# ASN-110728]",
                person: "Mathew Fox",
                status: "Putaway Complete",
              },
              {
                time: "3:30:13 PM (cST)",
                description: "Putaway Completed [# ASN-110728]",
                person: "Mathew Fox",
                status: "Putaway Complete",
              },
              {
                time: "3:30:13 PM (cST)",
                description: "Putaway Completed [# ASN-110728]",
                person: "Mathew Fox",
                status: "Putaway Complete",
              },
              {
                time: "3:30:13 PM (cST)",
                description: "Putaway Completed [# ASN-110728]",
                person: "Mathew Fox",
                status: "Putaway Complete",
              },
              {
                time: "3:30:13 PM (cST)",
                description: "Putaway Completed [# ASN-110728]",
                person: "Mathew Fox",
                status: "Putaway Complete",
              },
             ],
            },
          ];
export const HistoryLayoutDataOverViewDetails = [
            {
              day: "Today",
              items: [
                {
                  time: "3:30:13 PM (CST)",
                  description: "Putaway Completed [# ASN-110728]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:25:45 PM (CST)",
                  description: "Putaway Completed [# ASN-110729]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:20:12 PM (CST)",
                  description: "Putaway Completed [# ASN-110730]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:10:50 PM (CST)",
                  description: "Putaway Completed [# ASN-110731]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
              ],
            },
          ];
export const HistoryLayoutDataPurchaseOrderDetails = [
            {
              day: "Today",
              items: [
                {
                  time: "3:30:13 PM (CST)",
                  description: "Putaway Completed [# ASN-110728]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:25:45 PM (CST)",
                  description: "Putaway Completed [# ASN-110729]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:20:12 PM (CST)",
                  description: "Putaway Completed [# ASN-110730]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:10:50 PM (CST)",
                  description: "Putaway Completed [# ASN-110731]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
              ],
            },
          ];
export const HistoryLayoutDataReceiveDetails = [
            {
              day: "Today",
              items: [
                {
                  time: "3:30:13 PM (CST)",
                  description: "Putaway Completed [# ASN-110728]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:25:45 PM (CST)",
                  description: "Putaway Completed [# ASN-110729]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:20:12 PM (CST)",
                  description: "Putaway Completed [# ASN-110730]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:10:50 PM (CST)",
                  description: "Putaway Completed [# ASN-110731]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
              ],
            },
          ];
export const HistoryLaoutDataPutawayDetail = [
            {
              day: "Today",
              items: [
                {
                  time: "3:30:13 PM (CST)",
                  description: "Putaway Completed [# ASN-110728]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:25:45 PM (CST)",
                  description: "Putaway Completed [# ASN-110729]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:20:12 PM (CST)",
                  description: "Putaway Completed [# ASN-110730]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:10:50 PM (CST)",
                  description: "Putaway Completed [# ASN-110731]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
              ],
            },
          ];
export const HistoryLaoutDataUnloadDetail = [
            {
              day: "Today",
              items: [
                {
                  time: "3:30:13 PM (CST)",
                  description: "Putaway Completed [# ASN-110728]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:25:45 PM (CST)",
                  description: "Putaway Completed [# ASN-110729]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:20:12 PM (CST)",
                  description: "Putaway Completed [# ASN-110730]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:10:50 PM (CST)",
                  description: "Putaway Completed [# ASN-110731]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
              ],
            },
          ];
export const HistoryLaoutDataReturnsOverviewDetail = [
            {
              day: "Today",
              items: [
                {
                  time: "3:30:13 PM (CST)",
                  description: "Putaway Completed [# ASN-110728]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:25:45 PM (CST)",
                  description: "Putaway Completed [# ASN-110729]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:20:12 PM (CST)",
                  description: "Putaway Completed [# ASN-110730]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:10:50 PM (CST)",
                  description: "Putaway Completed [# ASN-110731]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
              ],
            },
          ];
export const HistoryLaoutDataReturnUnloadDetails = [
            {
              day: "Today",
              items: [
                {
                  time: "3:30:13 PM (CST)",
                  description: "Putaway Completed [# ASN-110728]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:25:45 PM (CST)",
                  description: "Putaway Completed [# ASN-110729]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:20:12 PM (CST)",
                  description: "Putaway Completed [# ASN-110730]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:10:50 PM (CST)",
                  description: "Putaway Completed [# ASN-110731]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
              ],
            },
          ];
export const HistoryLaoutDataReturnReceiveDetails = [
            {
              day: "Today",
              items: [
                {
                  time: "3:30:13 PM (CST)",
                  description: "Putaway Completed [# ASN-110728]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:25:45 PM (CST)",
                  description: "Putaway Completed [# ASN-110729]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:20:12 PM (CST)",
                  description: "Putaway Completed [# ASN-110730]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:10:50 PM (CST)",
                  description: "Putaway Completed [# ASN-110731]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
              ],
            },
          ];
export const HistoryLaoutDataReturnPutawayDetails = [
            {
              day: "Today",
              items: [
                {
                  time: "3:30:13 PM (CST)",
                  description: "Putaway Completed [# ASN-110728]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:25:45 PM (CST)",
                  description: "Putaway Completed [# ASN-110729]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:20:12 PM (CST)",
                  description: "Putaway Completed [# ASN-110730]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
                {
                  time: "3:10:50 PM (CST)",
                  description: "Putaway Completed [# ASN-110731]",
                  person: "Mathew Fox",
                  status: "Putaway Complete",
                },
              ],
            },
          ];
export const HistoryLayoutDataCompanyAccountDetails = [
            {
              day: "Today",
              items: [
                {
                  time: "12/02/2023 12:00:13 PM (CST)",
                  description: "Client Limit Increased",
                  person: "Mathew Fox",
                },
                {
                  time: "12/02/2023 12:00:13 PM (CST)",
                  description: "Warehouse Limit Increased",
                  person: "Mathew Fox",
                },
                {
                  time: "12/02/2023 12:00:13 PM (CST)",
                  description: "User Limit Increased",
                  person: "Mathew Fox",
                },
              ],
            },
            {
              day: "Yesterday",
              items: [
                {
                  time: "12/01/2023 12:00:13 PM (CST)",
                  description: "Client Limit Increased",
                  person: "Mathew Fox",
                },
                {
                  time: "12/01/2023 12:00:13 PM (CST)",
                  description: "Client Limit Increased",
                  person: "Mathew Fox",
                },
                {
                  time: "12/01/2023 12:00:13 PM (CST)",
                  description: "Client Limit Increased",
                  person: "Mathew Fox",
                },
              ],
            },
          ];
export const HistoryLayoutDataReplenishmentDetails = [
            {
              day: "Today",
              items: [
                {
                  time: "7:00:18 AM (CST)",
                  description: "Replenishment Completed Having Qty 32 85741231",
                  person: "Zack Brown",
                  status: "Completed",
                },
                {
                  time: "6:45:00 AM (CST)",
                  description: "Replenishment In Progress Having Qty 22 8574124",
                  person: "Zack Brown",
                  status: "In Progress",
                },
                {
                  time: "6:30:13 AM (CST)",
                  description: "Replenishment In Progress Having Qty 10 8574125",
                  person: "Zack Brown",
                  status: "In Progress",
                },
                {
                  time: "6:00:13 AM (CST)",
                  description: "Replenishment created Having Qty 10 85741261",
                  person: "Zack Brown",
                  status: "New",
                },
              ],
            },
          ];
export const HistoryLaoutDataCycleCountDetail = [
            {
              day: "Today",
              items: [
                {
                  time: "7:00:18 AM (CST)",
                  description: "Replenishment Completed Having Qty 32 85741231",
                  person: "Zack Brown",
                  status: "Completed",
                },
                {
                  time: "6:45:00 AM (CST)",
                  description: "Replenishment In Progress Having Qty 22 8574124",
                  person: "Zack Brown",
                  status: "In Progress",
                },
                {
                  time: "6:30:13 AM (CST)",
                  description: "Replenishment In Progress Having Qty 10 8574125",
                  person: "Zack Brown",
                  status: "In Progress",
                },
                {
                  time: "6:00:13 AM (CST)",
                  description: "Replenishment created Having Qty 10 85741261",
                  person: "Zack Brown",
                  status: "New",
                },
              ],
            },
          ];

export const HistoryLaoutBOMMaintenanceDetails =
[
    {
      day: "Today",
      items: [
        {
          time: "3:30:13 PM (CST)",
          description: "Kitting Completed [# ASN-110728]",
          person: "Mathew Fox",
          status: "Completed"
        },
        {
          time: "3:30:13 PM (CST)",
          description: "Kitting Completed [# ASN-110728]",
          person: "Mathew Fox",
          status: "In Progress"
        },
        {
          time: "3:30:13 PM (CST)",
          description: "Kitting Completed [# ASN-110728]",
          person: "Mathew Fox",
          status: "Completed"
        },
        {
          time: "3:30:13 PM (CST)",
          description: "Kitting Completed [# ASN-110728]",
          person: "Mathew Fox",
          status: "Completed"
        },
        {
          time: "3:30:13 PM (CST)",
          description: "Kitting Completed [# ASN-110728]",
          person: "Mathew Fox",
          status: "In Progress"
        },
        {
          time: "3:30:13 PM (CST)",
          description: "Kitting Completed [# ASN-110728]",
          person: "Mathew Fox",
          status: "In Progress"
        }
      ]
    }
  ]
  export const HistoryLaoutAdjustmentDetails =[
    {
      day: "Today",
      items: [
        {
          time: "7:00:18 AM (CST)",
          description: "Adjustment Completed Having Qty 32 85741231",
          person: "Zack Brown",
          status: "Completed"
        },
        {
          time: "6:45:00 AM (CST)",
          description: "Adjustment In Progress Having Qty 22 8574124",
          person: "Zack Brown",
          status: "In Progress"
        },
        {
          time: "6:30:13 AM (CST)",
          description: "Adjustment In Progress Having Qty 10 8574125",
          person: "Zack Brown",
          status: "In Progress"
        },
        {
          time: "6:00:13 AM (CST)",
          description: "Adjustment created Having Qty 10 85741261",
          person: "Zack Brown",
          status: "New"
        }
      ]
    }
  ]
  export const HistoryLaoutTransferDetails=[
    {
      day: "Today",
      items: [
        {
          time: "7:00:18 AM (CST)",
          description: "Stock Transfer Completed Having Qty 32 85741231",
          person: "Zack Brown",
          status: "Completed"
        },
        {
          time: "6:45:00 AM (CST)",
          description: "Stock Transfer In Progress Having Qty 22 8574124",
          person: "Zack Brown",
          status: "In Progress"
        },
        {
          time: "6:30:13 AM (CST)",
          description: "Stock Transfer In Progress Having Qty 10 8574125",
          person: "Zack Brown",
          status: "In Progress"
        },
        {
          time: "6:00:13 AM (CST)",
          description: "Stock Transfer created Having Qty 10 85741261",
          person: "Zack Brown",
          status: "New"
        }
      ]
    }
  ]
export const HistoryLaoutDataTransferEdit=[
    {
      day: "Today",
      items: [
        {
          time: "7:00:18 AM (CST)",
          description: "Stock Transfer Completed Having Qty 32 85741231",
          person: "Zack Brown",
          status: "Completed"
        },
        {
          time: "6:45:00 AM (CST)",
          description: "Stock Transfer In Progress Having Qty 22 8574124",
          person: "Zack Brown",
          status: "In Progress"
        },
        {
          time: "6:30:13 AM (CST)",
          description: "Stock Transfer In Progress Having Qty 10 8574125",
          person: "Zack Brown",
          status: "In Progress"
        },
        {
          time: "6:00:13 AM (CST)",
          description: "Stock Transfer created Having Qty 10 85741261",
          person: "Zack Brown",
          status: "New"
        }
      ]
    },
    {
      day: "Yesterday",
      items: [
        {
          time: "7:30:00 PM (CST)",
          description: "Check-in Complete Qty 50 [#ASN-11001 7B]",
          person: "Zack Brown",
          status: "Check-in Complete"
        },
        {
          time: "7:00:13 PM (CST)",
          description: "Ready To Check-in Qty 50 [#ASN-11 781]",
          person: "Zack Brown",
          status: "Ready to Check-in"
        },
        {
          time: "6:00:13 PM (CST)",
          description: "ASN Created Qty 50 [#ASN-11001781]",
          person: "Bobby Brown",
          status: "New"
        }
      ]
    }
  ]
    

           
export const item_code = [
    { item: 'Px0987654321', description: 'XBOX' },
    { item: 'Px0912345887', description: 'Console' },
    { item: 'Px0912377777', description: 'Mac Book' },
    { item: 'Px0912346666', description: 'Iphone 12' },
    { item: 'Px0912333333', description: 'Iphone 15' },
];

export const DataFromAPI4 = [
    { itemCode: 'CT1254',  Qty: 2, itemDescription: 'iPhone 14' },
    { itemCode: 'TB1544',  Qty: 1, itemDescription: 'Mac book' },
    { itemCode: 'IR-29539',  Qty: 3, itemDescription: 'iPhone 16' },
];
export const DataFromAPI5 = [
    { itemCode: 'IP-23339', itemtype: 'SA1', Qty: 2, itemDescription: 'iPhone 14' },
    { itemCode: 'IT-23229', itemtype: 'SA2', Qty: 3, itemDescription: 'Mac book' },
    { itemCode: 'IR-29539', itemtype: 'SA3', Qty: 1, itemDescription: 'iPhone 16' },
];

export const configureKitQty = [
    { value: 'IP-23339', label: 'IP-23339' },
    { value: 'IT-23229', label: 'IT-23229' },
    { value: 'IR-29539', label: 'IR-29539' }
]

export const bommaintenanceoverview = [ 
 
    {
        "bommaintenanceNum": "Px098429292",
        "description": "Xbox 360",
        "itemType": "Assembly",
        "noOfComponents": "2",
        "uom": "EA",
        "status": "Active"
    },{
        "bommaintenanceNum": "Px098429292",
        "description": "Xbox 360",
        "itemType": "Assembly",
        "noOfComponents": "2",
        "uom": "EA",
        "status": "Active"
    },{
        "bommaintenanceNum": "Px098429292",
        "description": "Xbox 360",
        "itemType": "Assembly",
        "noOfComponents": "3",
        "uom": "EA",
        "status": "Active"
    },{
        "bommaintenanceNum": "Px098429292",
        "description": "Xbox 360",
        "itemType": "Assembly",
        "noOfComponents": "4",
        "uom": "EA",
        "status": "Active"
    },{
        "bommaintenanceNum": "Px098429292",
        "description": "Xbox 360",
        "itemType": "Assembly",
        "noOfComponents": "2",
        "uom": "EA",
        "status": "Active"
    },
    {
        "bommaintenanceNum": "Px098429292",
        "description": "Xbox 360",
        "itemType": "Assembly",
        "noOfComponents": "2",
        "uom": "EA",
        "status": "Active"
    },{
        "bommaintenanceNum": "Px098429292",
        "description": "Xbox 360",
        "itemType": "Assembly",
        "noOfComponents": "2",
        "uom": "EA",
        "status": "Active"
    },{
        "bommaintenanceNum": "Px098429292",
        "description": "Xbox 360",
        "itemType": "Assembly",
        "noOfComponents": "2",
        "uom": "EA",
        "status": "Active"
    },{
        "bommaintenanceNum": "Px098429292",
        "description": "Xbox 360",
        "itemType": "Assembly",
        "noOfComponents": "3",
        "uom": "EA",
        "status": "Active"
    },{
        "bommaintenanceNum": "Px098429292",
        "description": "Xbox 360",
        "itemType": "Assembly",
        "noOfComponents": "2",
        "uom": "EA",
        "status": "Active"
    },{
        "bommaintenanceNum": "Px098429292",
        "description": "Xbox 360",
        "itemType": "Assembly",
        "noOfComponents": "2",
        "uom": "EA",
        "status": "Active"
    },
]
 
export const vewscanlogData=[
    {
        "unloadDetails": {
          "asn_no": "ASN-9974123",
          "startDateTime": "03/20/2020 14:20:34(CST)",
          "endDateTime": "03/21/2020 16:00:12(CST)",
          "duration": "3h 20m 24s",
          "historyLog": [
            {
              "date": "03/21/2020",
              "logs": [
                {
                  "time": "16:00:12(CST)",
                  "description": "Mathew fox scanned",
                  "location": "Location",
                  "location_no": "A1-P6",
                  "isError": 0
                },
                {
                  "time": "16:00:11(CST)",
                  "description": "Mathew fox scanned",
                  "location": "Itemcode",
                  "location_no": "LP UPC LP134567",
                  "isError": 0
                },
                {
                  "time": "16:00:10(CST)",
                  "description": "Mathew fox scanned",
                  "location": "Error ",
                  "location_no": "(invalid bin location scanned)",
                  "isError": 1
                },
                {
                    "time": "16:00:12(CST)",
                    "description": "Mathew fox scanned",
                    "location": "Location",
                    "location_no": "A1-P6",
                    "isError": 0
                  },
                  {
                    "time": "16:00:11(CST)",
                    "description": "Mathew fox scanned",
                    "location": "Itemcode",
                    "location_no": "LP UPC LP134567",
                    "isError": 0
                  },
              ]
            },
            {
              "date": "03/20/2020",
              "logs": [
                {
                  "time": "16:00:12(CST)",
                  "description": "Mathew fox scanned",
                  "location": "Location",
                  "location_no": "A1-P6",
                  "isError": 0
                },
                {
                  "time": "16:00:11(CST)",
                  "description": "Mathew fox scanned",
                  "location": "Itemcode",
                  "location_no": "LP UPC LP134567",
                  "isError": 0
                },
                {
                  "time": "16:00:10(CST)",
                  "description": "Mathew fox scanned",
                  "location": "Error",
                  "location_no": "(invalid bin location scanned)",
                  "isError": 1
                },
                {
                    "time": "16:00:12(CST)",
                    "description": "Mathew fox scanned",
                    "location": "Location",
                    "location_no": "A1-P6",
                    "isError": 0
                  },
                  {
                    "time": "16:00:11(CST)",
                    "description": "Mathew fox scanned",
                    "location": "Itemcode",
                    "location_no": "LP UPC LP134567",
                    "isError": 0
                  },
              ]
            }
          ]
        }
      }
      
      
]

  
